export const memo = <T extends Array<unknown>, R>(
    fn: (...args: T) => R
): ((key: string, ...args: T) => R) => {
    const cache = new Map<string, R>();

    return (key: string, ...args: T): R => {
        if (cache.has(key)) {
            return cache.get(key)!;
        }

        const result = fn(...args);
        cache.set(key, result);
        return result;
    };
};
